/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect,useRef } from "react";
import axios from "axios";

import DatePicker from "react-datepicker";
import { ko } from 'date-fns/esm/locale';
import "react-datepicker/dist/react-datepicker.css";

import ShowBigSizePhoto from "../../../components/popups/ShowBigSizePhoto";
import FoundDriverForSelect from "../../../components/popups/FoundDriverForSelect";
import FoundCustomerForSelect from "../../../components/popups/FoundCustomerForSelect";

import { isNull,isObjEmpty,SetCustomerLinesString,ChangeMobileFormat,ChangeMobileNumber,ChangeDateFormat,addThousandPoint,
        ChangeDateStringFormat,removeThousandPoint,ChangeToDateFormat,CheckDateFormat,ChangeDateStringOnlyDate,RemakeAddress,
        ChangeReceiptPayment,ShowDeliveryStatus} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const PopupDeliveryDetail = ({varDeliveryIndex,setDeliveryIndex,varDeliveryLists,setDeliveryLists,varShowDeliveryDetail,setShowDeliveryDetail}) => {

  const admin_idx = Number(localStorage.getItem("adminIdx"));
  const admin_id = localStorage.getItem("adminID");
  const admin_name = localStorage.getItem("adminName");
  const fileRef = useRef(null);

  //배차정보
  const [varDeliveryInfo,setDeliveryInfo] = useState({});
  //거래처 노선
  const [varCustomerLines,setCustomerLines] = useState([]);
  const [varEntireCustomerLines,setEntireCustomerLines] = useState([]);
  //인수증 사진
  const [varReceiptPhoto,setReceiptPhoto] = useState(null);
  //인수증 결제방법
  const [varReceiptPayment,setReceiptPayment] = useState([]);

  //날짜
  const [varPickupDate,setPickupDate] = useState({});
  
  //신규회원정보
  const newDelivery = {dc_idx:0,dc_mem_idx:admin_idx,admin_id:admin_id,admin_name:admin_name,dc_driver_idx:0,old_driver_idx:0,
        cs_idx:0,csl_idx:0,dc_riding_date:ChangeDateFormat(new Date()),dc_riding_address:'',dc_middle_address:'',
        dc_quit_date:ChangeDateFormat(new Date()),dc_quit_address:'',dc_volume:0,dc_price:0,dc_charge:7,dc_dprice:0,
        dc_rprice:0,dc_prd_name:'',dc_prd_quantity:0,dc_prd_req_ton:0,mem_alert_driving:1,dc_prd_slip:0,dc_prd_notice:'',
        dc_admin_memo:'',dc_receipt_image:0,dc_receipt_file:'',dc_rdate:null,dc_status:1,dc_reported:0,dc_paid:0};

  //회원정보 읽어오기
  const getDeliveryInformation = async (dc_idx) => {
    const sendData = {dc_idx:dc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_delivery_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      let paymentArray = [1,0,0,0];
      let cs_idx = 0;
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          cs_idx = dataInfo.cs_idx;
          dataInfo.old_driver_idx = dataInfo.dc_driver_idx; //현재 드라이버 저장
          setDeliveryInfo(dataInfo);
          if(dataInfo.dc_receipt_image===1){
            setReceiptPhoto(`${process.env.REACT_APP_HOST}/receipt/${dataInfo.dc_receipt_file}`);
          } else {
            setReceiptPhoto(null);
          }
          //인수증 결재방법
          if(!isNull(dataInfo.dc_receipt_payment)){
            paymentArray = dataInfo.dc_receipt_payment.split(',');
          }
          //console.log(paymentArray);
          setReceiptPayment(paymentArray);
          setPickupDate({...varPickupDate,dc_riding_date:dataInfo.dc_riding_date,dc_quit_date:dataInfo.dc_quit_date});
        }  else {
          setDeliveryInfo(newDelivery);
          setReceiptPayment(paymentArray);
          setReceiptPhoto(null);
        }
        if(datas.lines?.length > 0) {
          setEntireCustomerLines(datas.lines);
          const lineList = datas.lines.filter(el=>el.cs_idx===cs_idx);
          setCustomerLines(lineList);
        } else {
          setEntireCustomerLines([]);
          setCustomerLines([]);
        } 
      } else {
        setDeliveryInfo(newDelivery);
        setReceiptPayment(paymentArray);
        setEntireCustomerLines([]);
        setCustomerLines([]);
        setReceiptPhoto(null);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    const newDateData = {dc_riding_date:ChangeDateFormat(new Date()),dc_quit_date:ChangeDateFormat(new Date())};
    setPickupDate(newDateData);
    if(varDeliveryIndex>0) {
      newDelivery.dc_idx = varDeliveryIndex;
      getDeliveryInformation(varDeliveryIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varDeliveryIndex,varShowDeliveryDetail]);

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "mem_mobile") {
      setDeliveryInfo({...varDeliveryInfo,mem_mobile:ChangeMobileNumber(value)});
    } else if(name === "dc_volume" || name === "dc_price" || name === "dc_charge" || name === "dc_rprice" || name === "dc_prd_quantity" || name === "dc_prd_req_ton" || name === "dc_prd_slip"){
      let newprice = removeThousandPoint(value);
      console.log(newprice);
      setDeliveryInfo({...varDeliveryInfo,[name]:newprice});
    } else if(name === 'dr_carnumb') {
      setDeliveryInfo({...varDeliveryInfo,[name]:value});
    } else if(name === 'dc_reported' || name === 'dc_paid') {
      setDeliveryInfo({...varDeliveryInfo,[name]:Number(value)});
    } else if(name === 'dc_riding_date' || name === 'dc_quit_date') {
      let svalue = value.replace(/-/g, '');
      if(svalue.length === 8){
        const retArray = CheckDateFormat(svalue);
        if(!retArray.value) {
          setDeliveryInfo({...varDeliveryInfo,[name]:svalue});
          alert(retArray.message); return false;
        }
        svalue = ChangeDateStringFormat(value); 
        setPickupDate({...varPickupDate,[name]:svalue});
      } 
      setDeliveryInfo({...varDeliveryInfo,[name]:svalue});
    } else {
      setDeliveryInfo({...varDeliveryInfo,[name]:value});
    }
  }
  //날짜
  const onChangeDateHandler = (imode,ndate) => {
    let sdate = null;
    if(!isNull(ndate)) sdate = ChangeDateFormat(ndate);
    if(imode === 0) {
      setDeliveryInfo({...varDeliveryInfo,dc_riding_date:sdate});
      setPickupDate({...varPickupDate,dc_riding_date:sdate});
    } else {
      setDeliveryInfo({...varDeliveryInfo,dc_quit_date:sdate});
      setPickupDate({...varPickupDate,dc_quit_date:sdate});
    }
  }
  //인수증 결제방법
  const onReceiptPayemtHandler = (e,ino) => {
    let copyArray = [...varReceiptPayment];
    copyArray[ino] = Number(e.currentTarget.checked);
    
    if(ino === 0 && e.currentTarget.checked) {
      copyArray[1] = 0;
      copyArray[2] = 0;
      copyArray[3] = 0;
      const paycheckBoxes = document.querySelectorAll('.paycheck');
      for(var i=0; i < paycheckBoxes?.length; i++) {
        paycheckBoxes[i].checked = false;
      }
    } else {
      if(e.currentTarget.checked) {
        copyArray[0] = 0;
        const paynoneBoxes = document.getElementById('pay0');
        paynoneBoxes.checked = false;
      }
    }
    setReceiptPayment(copyArray);
  }

  //사진팝업보기
  const [varOpenPhoto,setOpenPhoto] = useState(false);
  const [varPhotoImage, setPhotoImage] = useState(null);
  const onShowBigSizePhotoHandler = (e,files) => {
    if(varDeliveryInfo.dc_receipt_image === 1) {
      setPhotoImage(files);
      setOpenPhoto(true);
    }
  }
  const onOpenPhotoHandler = (e,bmode) => {
    setOpenPhoto(bmode);
  }
  //드라이버 사진
  const onSelectPhotoHandler = (e) => {
    e.preventDefault();
    fileRef.current.click();
  }
  const onSelectedPhotoHandler = (e) => {
    e.preventDefault();
    if(e.currentTarget.value === "") return false;

    const uploadFile = e.currentTarget.files[0];
    //화면에 이미지 표시
    const spreview = URL.createObjectURL(uploadFile);
    setReceiptPhoto(spreview);
    setDeliveryInfo({...varDeliveryInfo,dc_receipt_image:1});
  }

  //드라이버 검색
  const [varOpenFindDriver,setOpenFindDriver] = useState(false);
  const [varSearchDriverList, setSearchDriverList] = useState('');

  const onSearchDriverHandler = async(e) => {
    if(varDeliveryInfo.dr_carnumb === "") {
      alert('검색할 차량번호를 먼저 입력하세요.'); return false;
    }
    const sendData = {dr_carnumb:varDeliveryInfo.dr_carnumb};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_find_driver`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length === 0) {
          alert('검색된 드라이버가 없습니다.')
        } else if(datas.results?.length === 1) {
          const driverInfo = datas.results[0];
          setDeliveryInfo({...varDeliveryInfo,dc_driver_idx:driverInfo.dr_mem_idx,mem_name:driverInfo.mem_name,mem_mobile:driverInfo.mem_mobile,
                        mem_alert_driving:driverInfo.mem_alert_driving,dr_carnumb:driverInfo.dr_carnumb});
        } else {
          //회원 검색을 비슷한 문자로 진행하는 경우 --> 목록으로 (추후검토))
          const driverList = datas.results;
          setSearchDriverList(driverList);
          setOpenFindDriver(true);
        }
      } else {
        alert(datas.message);
      }
    });
  }
  const SelectedDriverAmongFound = (e) => {
    const driver_idx = Number(e.currentTarget.value);
    if(driver_idx === 0) {
      alert('드라이버를 먼저 선택하세요,');
      return false;
    }
    setOpenFindDriver(false);
    const driverInfo = varSearchDriverList.filter(el=>el.dr_mem_idx === driver_idx)[0];
    setDeliveryInfo({...varDeliveryInfo,dc_driver_idx:driverInfo.dr_mem_idx,mem_name:driverInfo.mem_name,mem_mobile:driverInfo.mem_mobile,
                    mem_alert_driving:driverInfo.mem_alert_driving,dr_carnumb:driverInfo.dr_carnumb});
  }

  //거래처 검색
  const [varOpenFindCustomer,setOpenFindCustomer] = useState(false);
  const [varSearchCustomerList, setSearchCustomerList] = useState('');

  const onSearchCustomerHandler = async(e) => {
    if(varDeliveryInfo.cs_name === "") {
      alert('검색할 거래처의 이름을 먼저 입력하세요.'); return false;
    }
    const sendData = {cs_name:varDeliveryInfo.cs_name};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_find_customer`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const customerList = datas.results;
        if(datas.results?.length === 0) {
          setSearchCustomerList([]);
          alert('검색된 거래처가 없습니다.')
        } else if(datas.results?.length === 1) {
          const customerInfo = datas.results[0];
          setDeliveryInfo({...varDeliveryInfo,cs_idx:customerInfo.cs_idx,cs_name:customerInfo.cs_name,cs_code:customerInfo.cs_code});
          //거래처 노선 목록
          const lineList = varEntireCustomerLines.filter(el=>el.cs_idx===customerInfo.cs_idx);
          setCustomerLines(lineList);
        } else {
          //회원 검색을 비슷한 문자로 진행하는 경우 --> 목록으로 (추후검토))
          setSearchCustomerList(customerList);
          setOpenFindCustomer(true);
        }
      } else {
        alert(datas.message);
      }
    });  
  }
  const SelectedCustomerAmongFound = (e) => {
    const cs_idx = Number(e.currentTarget.value);
    if(cs_idx === 0) {
      setCustomerLines([]);
      alert('거래처를 먼저 선택하세요,');
      return false;
    }
    setOpenFindCustomer(false);
    const customerInfo = varSearchCustomerList.filter(el=>el.cs_idx === cs_idx)[0];
    setDeliveryInfo({...varDeliveryInfo,cs_idx:customerInfo.cs_idx,cs_name:customerInfo.cs_name,cs_code:customerInfo.cs_code});
    //거래처 노선 목록
    const lineList = varEntireCustomerLines.filter(el=>el.cs_idx===cs_idx);
    setCustomerLines(lineList);
  }

  //배차현황정보 저장 - 정보값확인 --> 이지미 저장
  const onUpdateDeliveryHandler = async (e) => {
    if(varDeliveryInfo.dc_driver_idx === 0) {
      alert('배정기사를 먼저 선택하세요.'); return false;
    } else if(varDeliveryInfo.cs_idx === 0) {
      alert('거래처를 먼저 선택하세요.'); return false;
    } else if(varDeliveryInfo.cs_riding_date === "") {
      alert('상차일을 먼저 입력하세요.'); return false;
    } else if(varDeliveryInfo.cs_riding_address === "") {
      alert('상차지를 먼저 선택하세요.'); return false;
    } else if(varDeliveryInfo.cs_quit_date === "") {
      alert('하차일을 먼저 입력하세요.'); return false;
    } else if(varDeliveryInfo.cs_quit_address === "") {
      alert('하차지를 먼저 선택하세요.'); return false;
    /* } else if(varDeliveryInfo.dc_volume === "" || Number(varDeliveryInfo.dc_volume) === 0) {
      alert('운행량을 먼저 입력하세요.'); return false; */
    /* } else if(varDeliveryInfo.dc_price === "" || Number(varDeliveryInfo.dc_price) === 0) {
      alert('운임료를 먼저 입력하세요.'); return false; */
    /* } else if(varDeliveryInfo.dc_charge === "" || Number(varDeliveryInfo.dc_charge) === 0) {
      alert('수수료율울 먼저 입력하세요.'); return false; */
    } else if(varDeliveryInfo.dc_prd_name === "") {
      alert('상품명을 먼저 입력하세요.'); return false;
    } else if(varDeliveryInfo.dc_prd_quantity === "" || Number(varDeliveryInfo.dc_prd_quantity) === 0) {
      alert('상품수량을 먼저 입력하세요.'); return false;
    /* } else if(varDeliveryInfo.dc_prd_req_ton === "") {
      alert('상품요청톤을 먼저 입력하세요.'); return false; */
    }

    let sprompt = "배차현황을 저장합니까?";
    if(varDeliveryInfo.dc_idx === 0) sprompt = "배차현황을 등록합니까?";
    if(!window.confirm(sprompt)) return false;

    const receiptFile = fileRef.current;
    if(receiptFile.value === "") {
      UpdateDeliveryInformation("");
    } else {
      //인수증
      let formData = new FormData();
      formData.append('receipt',receiptFile.files[0]);
      await axios.post(`${process.env.REACT_APP_HOST}/receipt`, formData).then((res) => {
        console.log(res.data);
        if(res.data.retvalue === 1) {
          const fileName = res.data.fileName; //배열
          //폐기물사진 DB 등록
          UpdateDeliveryInformation(fileName);
        }
      });
    }
  }
  //배차현황정보 저장
  const UpdateDeliveryInformation = async(fileName) => {
    const recepitPayment = varReceiptPayment.join(',');
    const sendData = {deliveryInfo:varDeliveryInfo,fileName:fileName,recepitPayment:recepitPayment};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_update_delivery_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //신규 - 드라이버가 선택되면 --> 드러이버에게 알림.
        if(varDeliveryInfo.dc_status === 1 && varDeliveryInfo.mem_alert_driving === 1) {
          if(!window.confirm('드라이버에게 배차내용을 전송합니까?')){
            GetCurrentDeliveryInformation();
          } else {
            SendPushMessage(varDeliveryInfo.dc_driver_idx);
          }
        } else {
          GetCurrentDeliveryInformation();
        }
      }
    });
  }
  //현재 선택된 배차현황값을 목록에 반영
  const GetCurrentDeliveryInformation = async() => {
    const sendData = {dc_idx:varDeliveryInfo.dc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_delivery_list_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const lineObj = datas.results[0];
        const newData = ChangeDeliveryDataFormat(lineObj);
        //바꾸기
        const copyList = [...varDeliveryLists];
        const findIndex = copyList.findIndex(el=>el.data24===varDeliveryInfo.dc_idx);
        copyList[findIndex] = newData;
        setDeliveryLists(copyList);
      } else {
        alert(datas.message);
      }
      setShowDeliveryDetail(false);
    });
  }
  const ChangeDeliveryDataFormat = (lineObj) => {
    var newData = {};
    newData['data1'] = lineObj.admin_name;
    newData['data2'] = ChangeDateStringOnlyDate(lineObj.dc_riding_date);
    newData['data3'] = ChangeDateStringOnlyDate(lineObj.dc_quit_date);
    newData['data4'] = RemakeAddress(lineObj.dc_riding_address,3);
    newData['data5'] = RemakeAddress(lineObj.dc_quit_address,3);
    newData['data6'] = lineObj.cs_code;
    newData['data7'] = lineObj.cs_name;
    newData['data8'] = lineObj.dr_carnumb;
    newData['data9'] = lineObj.driver_name;
    newData['data10'] = addThousandPoint(lineObj.dc_price);
    newData['data11'] = ChangeReceiptPayment(lineObj.dc_receipt_payment);
    newData['data12'] = lineObj.dc_receipt_image===1?"등록":lineObj.dc_receipt_image===-1?"없음":"미등록";
    newData['data13'] = lineObj.dc_prd_req_ton;
    newData['data14'] = lineObj.dc_prd_name;
    newData['data15'] = lineObj.dc_prd_quantity;
    newData['data16'] = lineObj.dc_volume;
    newData['data17'] = addThousandPoint(lineObj.dc_charge);
    newData['data18'] = addThousandPoint(lineObj.dc_rprice);
    newData['data19']= lineObj.dc_prd_notice;
    newData['data20'] = lineObj.dc_prd_slip===1?"Y":"N";
    newData['data21'] = ChangeMobileFormat(lineObj.driver_mobile);
    newData['data22'] = ShowDeliveryStatus(lineObj.dc_status);
    newData['data23'] = lineObj.dc_admin_memo;
    newData['data24'] = lineObj.dc_idx;
    newData['data25'] = 0;
    newData['data26'] = lineObj.dc_reported===0?"미신고":"신고";
    newData['data27'] = addThousandPoint(lineObj.dc_dprice);
    newData['data28'] = lineObj.staff_name;
    newData['data29'] = lineObj.dc_paid===1?"입금":"미입금";
    return newData;
  }
  //PUSH 메시지발송
  const SendPushMessage = async(dc_driver_idx) => {
    const pushMessage = `운행일자 : ${varDeliveryInfo.dc_riding_date}\n상차지 : ${varDeliveryInfo.dc_riding_address}\n하차지 : ${varDeliveryInfo.dc_quit_address}`;
    const sendData = {pushMode:1,opp_idx:dc_driver_idx,pushMessage:pushMessage};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_send_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        SavePushMessageHistory(dc_driver_idx,pushMessage);
      }
    });
  }
  //메시지발송내역 저장
  const SavePushMessageHistory = async(dc_driver_idx,pushMessage) => {
    const sendData = {ah_mem_idxs:dc_driver_idx,ah_mode:1,ah_message:pushMessage};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_insert_alarm_history`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        GetCurrentDeliveryInformation();
      } else {
        alert(datas.message);
      }
    });
  }
  //배차복제
  const onCopyDeliveryHander = async(e) => {
    if(!window.confirm('현재의 배차현황을 복제하여 등록하시겠습니까?')) return false;
    const sendData = {deliveryInfo:varDeliveryInfo,recepitPayment:'1,0,0,0'};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_copy_delivery_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message); 
      if(datas.retvalue === 1) {
        const newData = ChangeDeliveryDataFormat(datas.results[0]);
        setDeliveryLists(varDeliveryLists.concat(newData));
        setDeliveryIndex(datas.dc_idx); //현재 배차현황값을 복제된 새로운 값으로 변경
        getDeliveryInformation(datas.dc_idx);
      }
    });
  }

  //거래처 노선 선택
  const onSelectedCustomerLineHander = (e) => {
    const csl_idx = Number(e.currentTarget.value);
    console.log('csl_idx',e.currentTarget.value);
    if(csl_idx === 0) {
      setDeliveryInfo({...varDeliveryInfo,
        csl_idx:0,
        dc_riding_address:"",
        dc_middle_address:"",
        dc_quit_address:"",
        dc_price:0});
    } else {
      const selectLine = varCustomerLines.filter(el=>el.csl_idx===csl_idx);
      console.log(selectLine);
      setDeliveryInfo({...varDeliveryInfo,
        csl_idx:csl_idx,
        dc_riding_address:selectLine[0].csl_riding_address,
        dc_middle_address:isNull(selectLine[0].csl_middle_address)?'':selectLine[0].csl_middle_address,
        dc_quit_address:selectLine[0].csl_quit_address,
        dc_price:selectLine[0].csl_cost});
    }
  }

  //운임 계산
  useEffect(() => {
    if((!isNull(varDeliveryInfo.dc_price) || !isNull(varDeliveryInfo.dc_rprice)) && !isNull(varDeliveryInfo.dc_charge)) {
      let bprice = varDeliveryInfo.dc_price;
      if(!isNull(varDeliveryInfo.dc_rprice) && Number(varDeliveryInfo.dc_rprice) !== 0){
        bprice = varDeliveryInfo.dc_rprice;
      }
      const commit = Math.round(bprice * varDeliveryInfo.dc_charge / 100);  
      let dprice = Number(bprice) - commit;
      if(Number(bprice) < 0) dprice = Number(bprice) + commit;
      setDeliveryInfo({...varDeliveryInfo, dc_dprice:dprice});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varDeliveryInfo.dc_price,varDeliveryInfo.dc_rprice,varDeliveryInfo.dc_charge]);

  //키보드
  const onKeyPressHandler = (e,ino) => {
    if (e.key === 'Enter') {
      if(ino === 1) onSearchDriverHandler(e);
      else onSearchCustomerHandler(e);
    }
  }

  return (
    <div className={varShowDeliveryDetail?"page__pop open":"page__pop"}>
      <div className="page__pop__title">
        <div className="title">배차현황상세</div>
      </div>
      {varDeliveryIndex===0?null:
        <div className="btn-right" style={{paddingRight:"40px"}}>
          <button onClick={(e)=>onCopyDeliveryHander(e)} className="btn line">현재 배차현황을 복제</button>
        </div>
      }
      {isObjEmpty(varDeliveryInfo)?null:
        <div id="delivery_detail" className="admin-content">
          <h2 style={{marginBottom:"10px",fontSize:"18px"}}>- 배차담당자</h2>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>배차담당자</th>
                  <td>{admin_name||""}</td>
                  <th>아이디</th>
                  <td>{admin_id||""}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 style={{margin:"20px 0px 10px 0px",fontSize:"18px"}}>- 배정 기사</h2>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>배정기사&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td colSpan={3}>{varDeliveryInfo.mem_name||""}</td>
                </tr>
                <tr>
                  <th>차량번호</th>
                  <td>
                    <input type="text" name="dr_carnumb" value={varDeliveryInfo.dr_carnumb||""} style={{width:"200px"}} onKeyPress={e=>onKeyPressHandler(e,1)} onChange={onChangeInputHandler}/>
                    <button className="btn line black" onClick={e=>onSearchDriverHandler(e)}>검색</button>
                  </td>
                  <th>연락처</th>
                  <td>{ChangeMobileFormat(varDeliveryInfo.mem_mobile)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 style={{margin:"20px 0px 10px 0px",fontSize:"18px"}}>- 배차 정보</h2>
          <div className="main-box">
          <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>상차일&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td>
                    <input type="text" name="dc_riding_date" value={varDeliveryInfo.dc_riding_date} style={{width:"140px"}} onChange={onChangeInputHandler}/>
                    <DatePicker locale={ko} className="datepicker" selectsStart dateFormat="yyyy.MM.dd" selected={ChangeToDateFormat(varPickupDate.dc_riding_date)} onChange={(date)=>onChangeDateHandler(0,date)} />
                  </td>
                  <th>하차일&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td>
                    <input type="text" name="dc_quit_date" value={varDeliveryInfo.dc_quit_date} style={{width:"140px"}} onChange={onChangeInputHandler}/>
                    <DatePicker locale={ko} minDate={ChangeToDateFormat(varPickupDate.dc_riding_date)} className="datepicker" dateFormat="yyyy.MM.dd" selected={ChangeToDateFormat(varPickupDate.dc_quit_date||"")} onChange={(date)=>onChangeDateHandler(1,date)} />
                  </td>
                </tr>
                <tr>
                  <th>거래처명&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td>
                    <input type="text" name="cs_name" value={varDeliveryInfo.cs_name||""} style={{width:"250px"}} onKeyPress={e=>onKeyPressHandler(e,2)} onChange={onChangeInputHandler}/>
                    <button className="btn line black" onClick={onSearchCustomerHandler}>검색</button>
                  </td>
                  <th>거래처코드</th>
                  <td>{varDeliveryInfo.cs_code}</td>
                </tr> 
                <tr>
                  <th>노선&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td colSpan={3}>
                    <select name="csl_idx" style={{width:"450px"}} value={varDeliveryInfo.csl_idx} onChange={e=>onSelectedCustomerLineHander(e)}>
                      <option value={0}>노선없음(수기입력)</option>
                      {varCustomerLines.map((lines,i)=>(
                        <option key={'lines_'+i} value={lines.csl_idx}>{SetCustomerLinesString(lines)}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>상차지&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td colSpan={3}><input type="text" name="dc_riding_address" value={varDeliveryInfo.dc_riding_address||""} onChange={onChangeInputHandler}/></td>
                </tr>   
                <tr>
                  <th>경유지</th>
                  <td colSpan={3}><input type="text" name="dc_middle_address" value={varDeliveryInfo.dc_middle_address||""} onChange={onChangeInputHandler}/></td>
                </tr> 
                <tr>
                  <th>하차지&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td colSpan={3}><input type="text" name="dc_quit_address" value={varDeliveryInfo.dc_quit_address} onChange={onChangeInputHandler}/></td>
                </tr>
                <tr>
                  <th>운행량(Km)</th>
                  <td colSpan={3}>
                    <input type="text" name="dc_volume" style={{width:"150px"}} value={addThousandPoint(varDeliveryInfo.dc_volume)} onChange={onChangeInputHandler}/>&nbsp;Km
                  </td>
                </tr>   
                <tr>
                  <th>운임료(원)</th>
                  <td><input type="text" name="dc_price" style={{width:"200px"}} value={addThousandPoint(varDeliveryInfo.dc_price)||""} onChange={onChangeInputHandler}/>&nbsp;원</td>
                  <th>실운행가(원)</th>
                  <td><input type="text" name="dc_rprice" style={{width:"200px"}} value={addThousandPoint(varDeliveryInfo.dc_rprice)||""} onChange={onChangeInputHandler}/>&nbsp;원</td>
                </tr>  
                <tr>
                  <th>수수료율(%)&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td colSpan={3}><input type="text" name="dc_charge" style={{width:"200px"}} value={addThousandPoint(varDeliveryInfo.dc_charge)||0} onChange={onChangeInputHandler}/>&nbsp;%</td>
                </tr>  
                <tr>
                  <th>기사지급원가</th>
                  <td colSpan={3}><input type="text" name="dc_dprice" style={{width:"200px",backgroundColor:"#ccc"}} value={addThousandPoint(varDeliveryInfo.dc_dprice)||0} onChange={onChangeInputHandler} readOnly/>&nbsp;원</td>
                </tr> 
                <tr>
                  <th>상태</th>
                  <td>
                    <select name="dc_status" value={varDeliveryInfo.dc_status||0} onChange={onChangeInputHandler}>
                      <option value={0}>종료</option>
                      <option value={1}>운송전</option>
                      <option value={2}>상차완료</option>
                      <option value={3}>하차완료</option>
                      <option value={4}>운송완료</option>
                    </select>
                  </td>
                </tr>            
              </tbody>
            </table>
          </div>
          <h2 style={{margin:"20px 0px 10px 0px",fontSize:"18px"}}>- 상품 정보</h2>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>상품&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td><input type="text" name="dc_prd_name" value={varDeliveryInfo.dc_prd_name||""} onChange={onChangeInputHandler}/></td>
                  <th>수량&nbsp;<span style={{color:"red",fontSize:"12px"}}>(필수)</span></th>
                  <td><input type="text" name="dc_prd_quantity" style={{width:"200px"}} value={addThousandPoint(varDeliveryInfo.dc_prd_quantity||0)} onChange={onChangeInputHandler}/></td>
                </tr>
                <tr>
                  <th>요청톤</th>
                  <td><input type="text" name="dc_prd_req_ton" style={{width:"200px"}} value={addThousandPoint(varDeliveryInfo.dc_prd_req_ton||0)} onChange={onChangeInputHandler}/>&nbsp;톤</td>
                  <th>전자전표</th>
                  <td>
                    <input type="radio" name="dc_prd_slip" id="dc_prd_slip0" value={0} defaultChecked={varDeliveryInfo.dc_prd_slip===0} onChange={onChangeInputHandler}/>
                    <label htmlFor="dc_prd_slip0">없음</label>
                    <input type="radio" name="dc_prd_slip" id="dc_prd_slip1" value={1} defaultChecked={varDeliveryInfo.dc_prd_slip===1} onChange={onChangeInputHandler}/>
                    <label htmlFor="dc_prd_slip1">있음</label>
                  </td>
                </tr>
                <tr>
                  <th>유의사항</th>
                  <td colSpan={3}><textarea name="dc_prd_notice" style={{height:"120px"}} value={varDeliveryInfo.dc_prd_notice||""} onChange={onChangeInputHandler}/></td>
                </tr>
                <tr>
                  <th>관리자 메모</th>
                  <td colSpan={3}><textarea name="dc_admin_memo" style={{height:"120px"}} value={varDeliveryInfo.dc_admin_memo||""} onChange={onChangeInputHandler}/></td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 style={{margin:"20px 0px 10px 0px",fontSize:"18px"}}>- 인수증 등록</h2>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>인수증 결제방법</th>
                  <td>
                    <input type="checkbox" className="paycheck" id="pay1" checked={Number(varReceiptPayment[1])} onChange={e=>onReceiptPayemtHandler(e,1)}/>
                    <label htmlFor="pay1">우편</label>
                    <input type="checkbox" className="paycheck" id="pay2" checked={Number(varReceiptPayment[2])} onChange={e=>onReceiptPayemtHandler(e,2)}/>
                    <label htmlFor="pay2">사진</label>
                    <input type="checkbox" className="paycheck" id="pay3" checked={Number(varReceiptPayment[3])} onChange={e=>onReceiptPayemtHandler(e,3)}/>
                    <label htmlFor="pay3">팩스</label>
                    <input type="checkbox" id="pay0" checked={Number(varReceiptPayment[0])} onChange={e=>onReceiptPayemtHandler(e,0)}/>
                    <label htmlFor="pay0">없음</label>
                  </td>
                  <th>인수증 등록상태</th>
                  <td>
                    <select name="dc_receipt_image" value={varDeliveryInfo.dc_receipt_image}  onChange={onChangeInputHandler}>
                      <option value="0">미등록</option>
                      <option value="1">등록</option>
                      <option value="-1">없음</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>인수증
                    <input type="file" style={{display:"none"}} ref={fileRef} accept={"image/*"} onChange={onSelectedPhotoHandler} />
                    <input type="button" value="파일추가" onClick={onSelectPhotoHandler} />
                  </th>
                  <td colSpan="3" className="image-block">
                    <div className="image-box">
                      <img className="request-image" style={{height:"100%"}} src={varReceiptPhoto} alt="" onClick={(e)=>onShowBigSizePhotoHandler(e,varReceiptPhoto)}/>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* 실적신고 */}
          <h2 style={{margin:"20px 0px 10px 0px",fontSize:"18px"}}>- 실적 신고</h2>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="80%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>실적신고여부</th>
                  <td>
                    <input type="radio" name="dc_reported" value={1} className="paycheck" id="report1" checked={varDeliveryInfo.dc_reported===1} onChange={onChangeInputHandler}/>
                    <label htmlFor="report1">신고</label>
                    <input type="radio" name="dc_reported" value={0} className="paycheck" id="report0" checked={varDeliveryInfo.dc_reported===0} onChange={onChangeInputHandler}/>
                    <label htmlFor="report0">미신고</label>
                  </td>
                </tr>
                <tr>
                  <th>입금여부</th>
                  <td>
                    <input type="radio" name="dc_paid" value={1} className="paycheck" id="paid1" checked={varDeliveryInfo.dc_paid===1} onChange={onChangeInputHandler}/>
                    <label htmlFor="paid1">입금</label>
                    <input type="radio" name="dc_paid" value={0} className="paycheck" id="paid0" checked={varDeliveryInfo.dc_paid===0} onChange={onChangeInputHandler}/>
                    <label htmlFor="paid0">미입금</label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <button className="btn line black" onClick={()=>setShowDeliveryDetail(false)}>닫기</button>
            <button className="btn-danger" style={{width:"100px"}} onClick={(e)=>onUpdateDeliveryHandler(e)}>저장</button>
          </div>
        </div>
      }
      <ShowBigSizePhoto varPhotoImage={varPhotoImage} varOpenPhoto={varOpenPhoto} onOpenPhotoHandler={onOpenPhotoHandler}/>
      <FoundDriverForSelect varOpenFindDriver={varOpenFindDriver} setOpenFindDriver={setOpenFindDriver}
          varSearchDriverList={varSearchDriverList} SelectedDriverAmongFound={SelectedDriverAmongFound}/>
      <FoundCustomerForSelect varOpenFindCustomer={varOpenFindCustomer} setOpenFindCustomer={setOpenFindCustomer}
          varSearchCustomerList={varSearchCustomerList} SelectedCustomerAmongFound={SelectedCustomerAmongFound}/>
    </div>  
  );

}
export default PopupDeliveryDetail;